import { IDENTITY_CONFIG, METADATA_OIDC } from "../../Config/authConstants";
// import { UserManager, WebStorageStateStore, Log } from "oidc-client";
import { store } from '../../index';

export default class AuthService {
    UserManager;
    appSettings;

    constructor(props) {
        this.appSettings = props.appSettings;
        // this.UserManager = new UserManager({
        //     ...IDENTITY_CONFIG(props),
        //     userStore: new WebStorageStateStore({ store: window.sessionStorage }),
        //     metadata: {
        //         ...METADATA_OIDC(props)
        //     }
        // });
        // Logger
        // Log.logger = console;
        // Log.level = Log.DEBUG;
        // this.UserManager.events.addUserLoaded((user) => {
        //     if (!!user) {
        //         console.log("AddUserLoadedEvent, user: ");
        //         console.log(user);
        //         console.log(user.profile);

        //         console.log(user.profile.given_name);
        //         store.dispatch(setUserToken(user.access_token));

        //         store.dispatch(setUserInfo(user.profile));
        //         localStorage.setItem("id_token", user.id_token);
        //     }
        //     if (window.location.href.indexOf("signin-oidc") !== -1) {
        //         this.navigateToScreen();
        //     }
        // });
        // this.UserManager.events.addSilentRenewError((e) => {
        //     console.log("silent renew error", e.message);
        // });

        // this.UserManager.events.addAccessTokenExpired(() => {
        //     this.signinSilent();
        // });
    }

    signinRedirectCallback = () => {
        this.UserManager.signinRedirectCallback().then((user) => {
            console.log("signinRedirectCallback, user: ");
            console.log(user);
            
            // window.history.replaceState({},
            //     window.document.title,
            //     window.location.origin + window.location.pathname);
            //window.location = "index.html";
        });
    };

    getUser = async () => {
        const user = await this.UserManager.getUser();
        console.log("getUser, user: ");
        console.log(user);
        if (!user) {
            return await this.UserManager.signinRedirectCallback();
        }

        return user;
    };

    getUserAsync = () => (this.UserManager.getUser());

    parseJwt = (token) => {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        return JSON.parse(window.atob(base64));
    };

    signinRedirect = () => {
        localStorage.setItem("redirectUri", window.location.pathname);
        this.UserManager.signinRedirect({});
    };

    navigateToScreen = () => {
        window.location = this.appSettings.REACT_APP_URL;
    };

    isAuthenticated = () => {
        const oidcStorage = JSON.parse(sessionStorage.getItem(`oidc.user:${this.appSettings.FLAGSTONE_IDP_BASE_URL}:${this.appSettings.FLAGSTONE_IDP_CLIENT_ID}`))
        return (!!oidcStorage && !!oidcStorage.access_token)
    };

    signinSilent = () => {
        this.UserManager.signinSilent()
            .then((user) => {
                console.log("signed in", user);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    signinSilentCallback = () => {
        this.UserManager.signinSilentCallback();
    };

    createSigninRequest = () => {
        return this.UserManager.createSigninRequest();
    };

    logout = () => {
        this.UserManager.signoutRedirect({
            id_token_hint: localStorage.getItem("id_token")
        });
        this.UserManager.clearStaleState();
    };

    signoutRedirectCallback = () => {
        this.UserManager.signoutRedirectCallback().then(() => {
            localStorage.clear();
            window.location = this.appSettings.REACT_APP_URL;
        });
        this.UserManager.clearStaleState();
    };
}